const isCool = function(vehicle) {
    let trunk_category = vehicle.trunk_category || '';

    return trunk_category.toLowerCase() === 'cool';
};

export default {
    isCool: isCool
}



// WEBPACK FOOTER //
// ./src/helpers/Vehicle.js